import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Iframe from 'react-iframe';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { getContractorPitLookupData } from 'Redux/actions/LookupActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { EmptyWrapper, FilterCol, FilterRow, IframeWrapper, PageWrapper, RoundedWrapper, StyledDatePicker} from './styles';
import lo from 'lodash';
import moment from 'moment'
import FormSelect from 'components/atoms/Inputs/FormSelect';
import { Label } from 'components/atoms/Texts/TxtLabel';
import IconPng from 'components/atoms/IconPng/index';
import { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom'
import { TxtLink } from 'components/atoms/Texts/TxtLink';

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_folder = require('App/assets/images/ic_folder.png')
const ic_arrow_left = require('App/assets/images/ic_arrow_left.png');

const defaultFilter = {
  blastingDate: new Date(),
  pitId: '',
  contractorId: '',
}
export class BlastingReportSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filter: lo.cloneDeep(defaultFilter),
      lookups: {
        pits: [],
        contractors: []
      },
      localFilter: { pitId : '' },
      reportUri: null,
      navList: [
        'Blasting Report',
        'Blasting Report Summary'
      ],
    }

  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getContractorPitLookupData()
    this.initFilter()
  }

  componentDidUpdate() {
    const { REPORT_URL } = process.env
    const { viewState: { isLoading } } = this.props
    const { blastingDate, contractorId, pitId } = this.state.filter
    const query = new URLSearchParams({
      DATE: blastingDate ? moment(blastingDate).format('YYYY-MM-DD') : '',
      CONTRACTOR_ID: !!contractorId && contractorId !== '-' ? contractorId : '',
      PIT_ID: !!pitId && pitId !== '-' ? pitId : '',
    })
    if (isLoading) {
      this.setState({ reportUri: `${REPORT_URL}BEK_BLASTING_REPORT_MAIN&${query}` }, () => {
        this.props.toggleIsLoading(false)
      })
    }
  }

  initFilter() {
    if (sessionStorage.getItem('dataBlastingFilters') && sessionStorage.getItem('dataBlastingLookups')) {
      const filter = JSON.parse(sessionStorage.getItem('dataBlastingFilters'))
      const lookups = JSON.parse(sessionStorage.getItem('dataBlastingLookups'))
      this.setState({ filter: {
        ...filter,
        blastingDate: moment(filter.blastingDate).toDate()
      }, lookups }, () => {
        this.onFilterSubmit()
      })
    }
  }

  // method to change filter state
  onChangeFilter(val, field) {
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f }, () => {
      if (field === 'contractorId') {
        const { contractorPitLookups } = this.props
        const pits = !val ? 
          contractorPitLookups.map(el => el.pits).flat() : 
          contractorPitLookups.find(el => el.id === Number(val)).pits
        this.setState({ lookups: {
          ...this.state.lookups,
          pits: pits || []
        }, filter: { 
          ...this.state.filter,
          pitId : '' 
        } })
      }
    })
  }

  onFilterSubmit() {
    this.props.toggleIsLoading(true)
    const { blastingDate, contractorId, pitId } = this.state.filter
    const { REPORT_URL } = process.env
    const query = new URLSearchParams({
      DATE: blastingDate ? moment(blastingDate).format('YYYY-MM-DD') : '',
      CONTRACTOR_ID: !!contractorId && contractorId !== '-' ? contractorId : '',
      PIT_ID: !!pitId && pitId !== '-' ? pitId : '',
    })
    this.setState({ localFilter: { pitId }})
    this.setState({ reportUri: `${REPORT_URL}BEK_BLASTING_REPORT${query}` }, () => {
      this.props.toggleIsLoading(false)
    })
  }

  onResetFilter() {
    this.setState({ filter: lo.cloneDeep(defaultFilter) }, () => {
      this.setState({ localFilter: { pitId : '' } })
      this.onFilterSubmit()
    })
  }

  getPitFilterData(data, pitId) {
    return pitId && pitId !== '-' ? data.filter(item => {
      return item.pit === pitId
    }) : data
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  renderFilterRow(isContractor) {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
    }

    const { filter, lookups } = this.state

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Date
          </Label>
          <StyledDatePicker
            onChange={date => this.onChangeFilter( date, 'blastingDate')}
            value={filter.blastingDate}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Contractor
          </Label>
          <FormSelect
            placeholder={`Select contractor`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'contractorId')}
            options={[
              ...isContractor ? [] : [{
                name: 'All Contractors',
                id: ''
              }], 
              ...lookups.contractors]
            }
            value={filter.contractorId}
            valField={'id'}
            dispField={'name'}
            arrowSize={'5%'}
            {...inputConfig}
          />
        </FilterCol>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Pit
          </Label>
          <FormSelect
            placeholder={`Select pit`}
            onChangeVal={e => this.onChangeFilter(e.target.value, 'pitId')}
            options={[{
              name: 'All Pits',
              id: ''
            }, ...lookups.pits]}
            value={filter.pitId}
            valField={'id'}
            dispField={'name'}
            arrowSize={'5%'}
            mr={window.innerWidth <= 960 ? '.5rem' : '1.5rem'}
            {...inputConfig}
          />
        </FilterCol>

        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={filter.contractorId === '' || filter.contractorId === '-'}
          onClick={this.onFilterSubmit.bind(this)}
          width={'34px'}
          height={'34px'}
          margin={'0 9px 0 0'}
        />
        <ButtonReg
          btnTxt="Reset"
          rad={'6px'}
          disabled={false}
          onClick={this.onResetFilter.bind(this)}
          height={'34px'}
          width={'50px'}
        />
      </FilterRow>
    )
  }

  render() {
    const { navList, reportUri } = this.state
    const { userLogin, history: { goBack }, viewState: { isLoading, isMobileView }, theme } = this.props
    const isContractor = !!userLogin.userDetail.contractorId

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        <TxtLink weight={'bold'} color={theme.mocaPurple} size={'14'} showPointer onClick={() => goBack()}>
          <IconPng srcIcon={ic_arrow_left} showPointer={true} mr={'8px'} mb={'3px'} size={'auto'} h={'13'} />
          Back to Blasting Report List
        </TxtLink>
        <RoundedWrapper>
          {this.renderFilterRow(isContractor)}
        </RoundedWrapper>
        {!isLoading &&
        <div className={'col-12 px-0 pt-3 text-center'}>
        {reportUri ?
          <IframeWrapper>
            <Iframe
              url={reportUri}
              width="100%"
              height={this.getIframeHeight()}
              id="myId"
              className="myClassname"
              display="initial"
              position="relative" />
          </IframeWrapper> :
          <EmptyWrapper>
            <div>
              <IconPng srcIcon={ic_folder} size={'auto'} h={'86'} mb={'20px'} />
            </div>
            <Label weight={'600'} lineheight={'14px'} mb={'35px'} size={'12px'}>
              Select “filter” and click “view” button to see the report
            </Label>
          </EmptyWrapper>
        }
      </div>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contractorPitLookups: state.contractorPitLookups,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable,
    blastingReports: state.blastingReports,
    pitsLookup: state.contractorPitLookups.reduce((acc, item) => {
      item.pits.forEach(pit => {
        acc.push(pit)
      })
      return acc
    }, [])
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getContractorPitLookupData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BlastingReportSummary)
  )
)
